<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <div class="px-6 py-4 flex flex-col h-full min-h-48">
      <div class="flex-1">
        <h2 class="text-2xl font-bold text-center mb-2">Vuoi uscire?</h2>
        <p class="text-gray-500 text-center mb-6">
          Se esci ora perderai tutti i dati inseriti e dovrai ricominciare la registrazione dall'inizio.
        </p>
      </div>
      <div class="flex gap-3 mt-auto">
        <CuButton dark class="flex-1" @click="$emit('close')">Rimani</CuButton>
        <CuButton primary class="flex-1" @click="$emit('confirm')">Esci</CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "ExitConfirmationSheet",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false }
  }
}
</script>
